"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var NoImage_1 = require("../../../../../components/NoImage");
var react_i18next_1 = require("react-i18next");
var strings_1 = require("../../../../../helpers/strings");
var Price_1 = __importDefault(require("../../../../../components/Price"));
var GeneralSettings_1 = require("../../../../../constants/GeneralSettings");
var DailyMonthlyPrice_1 = __importDefault(require("../../../../../components/DailyMonthlyPrice"));
var mediaHelper_1 = require("../../../../../helpers/mediaHelper");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MarkerInfoWindow = function (_a) {
    var selectedMarker = _a.selectedMarker;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.grid_container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.image_column }, selectedMarker.image ? (react_1.default.createElement("img", { src: mediaHelper_1.resolveThumbByExtension(selectedMarker.image), alt: "" })) : (react_1.default.createElement(NoImage_1.NoImage, null))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.info_column },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.type }, t('POST_PREVIEW.' +
                selectedMarker.propertyType.toUpperCase())),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.price }, selectedMarker.deal === GeneralSettings_1.DEAL_TYPES.SELL ? (react_1.default.createElement(Price_1.default, { value: selectedMarker.priceFull, className: "price", defaultValue: t('POST_CARD.CONTRACTUAL') })) : (react_1.default.createElement(DailyMonthlyPrice_1.default, { monthlyPrice: selectedMarker.priceFull, dailyPriceFull: selectedMarker.dailyPriceFull }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.info },
                react_1.default.createElement("div", { className: "info-item" },
                    react_1.default.createElement("i", { className: "cm-icon icon-rooms" }),
                    react_1.default.createElement("span", null, strings_1.valueOrDash(selectedMarker.rooms))),
                react_1.default.createElement("div", { className: "info-item" },
                    react_1.default.createElement("i", { className: "cm-icon icon-square-m" }),
                    react_1.default.createElement("span", null, strings_1.valueOrDash(selectedMarker.area)))))));
};
exports.default = react_1.memo(MarkerInfoWindow);
